import { ChangeSocialObjectType } from "../../types/changeSocialObjective/changeSocialObjectType";

export const initialChangeSocialObjectState: ChangeSocialObjectType = {
    type: "",
    socialObject: ""
}